import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormInstance } from 'antd';
import PackageSizeCard from './PackageSizeCard';
import { PaymentCard } from './PaymentCard';
import { OrderOption, PaymentType, Preview, ShipmentFeeType } from '@/types';
import { OrderTypeEnum } from '@/stores/useOrderTypeStore';
import OrderTypeCard from './OrderTypeCard';

interface PackageAndPaymentCardProps {
  form: FormInstance;
  onPackageSizeChange: (size: string) => void;
  orderPrice: Preview;
  orderPriceLoading: boolean;
  paymentType?: PaymentType;
  shipmentFeeType?: ShipmentFeeType;
  packageSize?: string;
  onCustomShipmentFeeChange: (shipmentFee?: number) => void;
  customShipmentFee?: number;
  orderStatus?: string;
  orderOptions?: OrderOption[];
  clueVerificationLink?: string;
  idCheck?: boolean;
  hasFragileProduct?: boolean;
  discountAmount?: number;
  prepaymentAmount?: number;
  onOrderTypeChange?: (value: OrderTypeEnum) => void;
  /** Passed straight through to PaymentCard — see its prop doc. */
  blockedReason?: string | null;
}

const PackageAndPaymentCard: React.FC<PackageAndPaymentCardProps> = ({
  form,
  onPackageSizeChange,
  orderPrice,
  orderPriceLoading,
  paymentType,
  shipmentFeeType,
  packageSize,
  onCustomShipmentFeeChange,
  customShipmentFee,
  orderStatus,
  orderOptions,
  clueVerificationLink,
  idCheck,
  hasFragileProduct,
  discountAmount,
  prepaymentAmount,
  onOrderTypeChange,
  blockedReason,
}) => {
  return (
    <>
      <PackageSizeCard
        form={form}
        orderStatus={orderStatus}
        packageSizeProp={packageSize}
        onPackageSizeChange={onPackageSizeChange}
        orderOptions={orderOptions}
        idCheck={idCheck}
        clueVerificationLink={clueVerificationLink}
        hasFragileProduct={hasFragileProduct}
        boxBreakdown={orderPrice?.boxes}
      />

      <OrderTypeCard form={form} orderStatus={orderStatus} onOrderTypeChange={onOrderTypeChange} />

      <PaymentCard
        form={form}
        orderPrice={orderPrice}
        orderPriceLoading={orderPriceLoading}
        paymentType={paymentType}
        shipmentFeeType={shipmentFeeType}
        onCustomShipmentFeeChange={onCustomShipmentFeeChange}
        customShipmentFee={customShipmentFee}
        discountAmount={discountAmount}
        prepaymentAmount={prepaymentAmount}
        blockedReason={blockedReason}
      />
    </>
  );
};

export default PackageAndPaymentCard;
